<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jNDRki/tc-custom/9781643361253.jpg?1705291371131" alt="This image is the cover for the book Never in a Hurry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Never in a Hurry
      </h1>
      <p class="bookDescription body article font2">
        <b>From the acclaimed poet and National Book Award finalist, “a sparkling book of travel and childhood: born on the bridge between two cultures” (Paulette Jiles, <i>New York Times</i>–bestselling author).</b><br/><br/>In <i>Never in a Hurry </i>the poet Naomi Shihab Nye resist the American inclination to “leave toward places when we barely had time enough to get there.” Instead she travels the world at an observant pace, talking to strangers and introducing readers to an endearing assemblage of eccentric neighbors, Filipina faith healers, dry-cleaning proprietors, and other quirky characters.<br/><br/>A Palestinian-American who lives in a Mexican-American neighborhood, Nye speaks for the mix of people and places that can be called the “American Experience.” From St. Louis, the symbolic “Gateway to the West,” she embarks on a westward migration to examine America, past and present, and to glimpse into the lives of its latest outsiders—illegal immigrants from Mexico and troubled inner-city children.<br/><br/>In other essays Nye ventures beyond North America’s bounds, telling of a year in her childhood spent in Palestine and of an adulthood filled with cross-cultural quests. Whether recounting the purchase of a car on the island of Oahu or a camel-back ride through India’s Thar Desert, Nye writes in wry, refreshing tones about themes that transcend borders and about the journey that remains the greatest of all—the journey from outside to in as the world enters each one of us, as we learn to see.<br/><br/>“The generous gift of a writer at the top of her form, a book jammed with vivid sights and pungent tastes and wonderful stories.” —Marion Winik, author of <i>Above Us Only Sky</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naomi Shihab Nye
      </h2>
      
      <p class="authorDescription body article"><P>Naomi Shihab Nye was born in 1952 and lives in San Antonio, Texas. Her poetry volumes include Red Suitcase and Words Under the Words: Selected Poems. Editor of This Same Sky, and award-winning anthology of international poetry, Nye is featured on two PBS poetry specials, "The Language of Life with Bill Moyers" and "The United States of Poetry."</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60c1963a